import { render, staticRenderFns } from "./UserCustomers.vue?vue&type=template&id=43f22b12"
import script from "./UserCustomers.vue?vue&type=script&lang=js"
export * from "./UserCustomers.vue?vue&type=script&lang=js"
import style0 from "./UserCustomers.vue?vue&type=style&index=0&id=43f22b12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports